// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InstructionsTextBlock_wrapper__3PUOz","text":"InstructionsTextBlock_text__IbiL8"};